export interface PetTypeOption {
    label: string;
    value: string;
}

export const BASIC_PET_TYPE_OPTIONS: PetTypeOption[] = [
    {label: "Dog", value: "CANINE"},
    {label: "Cat", value: "FELINE"},
    {label: "Other", value: "OTHER"},
];

export const isBasicPetType = (typeValue: string) =>
    typeValue === "CANINE" || typeValue === "FELINE";

export const getBasicTypeSelection = (
    typeValue: string,
    isOtherTypeSelected: boolean
): PetTypeOption | null => {
    if (typeValue === "CANINE") {
        return BASIC_PET_TYPE_OPTIONS[0];
    }
    if (typeValue === "FELINE") {
        return BASIC_PET_TYPE_OPTIONS[1];
    }
    if (isOtherTypeSelected || (typeValue && !isBasicPetType(typeValue))) {
        return BASIC_PET_TYPE_OPTIONS[2];
    }
    return null;
};

export const getOtherPetTypes = (petTypes: PetTypeOption[]) =>
    petTypes.filter(type => !isBasicPetType(type.value));
